angular
    .module('empower.control')
    .service('localityService', ['$rootScope', '$filter', '$q', 'httpService',
        function ($rootScope, $filter, $q, httpService) {
            return {
                searchLocality: searchLocality
            };

            function searchLocality(pageNumber, rowsPerPage, keyword) {
                var def = $q.defer(),
                    APITarget = "api/postcode/searchLocality",
                    Values = JSON.stringify({
                        //Identifier: $rootScope.user.Identifier,
                        // SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        // DateOfBirth: $rootScope.user.DateOfBirth,
                        // IsClaimant: $rootScope.user.IsClaimant,
                        PageNumber: pageNumber,
                        RowsPerPage: rowsPerPage,
                        Keyword: keyword
                    });

                httpService.httpRequest(APITarget, Values, 'GET').then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            }
        }
    ]);